export interface SortOption {
  value: string
  label: string
}

export const sortOptions: SortOption[] = [
  { value: 'price', label: 'kyrgyzstan_block.sort.options.price_asc' },
  { value: '-price', label: 'kyrgyzstan_block.sort.options.price_desc' },
]

export const defaultSortOptionValue = sortOptions[0].value
